export const PARTNERS = "PARTNERS";
export const PARTNERS_LOADING = "PARTNERS_LOADING";
